import {
  contractTypeOptions,
  renewalIndicatorOptions,
} from "@/features/license-fee/list/utils/private-office-contract-mappings";

export const loader = () => {
  return {
    contractTypeOptions,
    renewalIndicatorOptions,
  };
};

export type LoaderData = Awaited<ReturnType<typeof loader>>;
